import { render, staticRenderFns } from "./admin.layout.vue?vue&type=template&id=474bfe7c&scoped=true"
import script from "./admin.layout.ts?vue&type=script&lang=ts&external"
export * from "./admin.layout.ts?vue&type=script&lang=ts&external"
import style0 from "./admin.layout.vue?vue&type=style&index=0&id=474bfe7c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474bfe7c",
  null
  
)

export default component.exports